module.exports = __webpack_public_path__ + "assets/images/UNFIT2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT2.png
// module id = 1441
// module chunks = 1